import React from 'react'

import { TDashboard } from 'types/GlobalDashboard'
import { useDashboardFilter } from 'redux/hooks/DashboardPage'
import FilterBar, { FilterBarProps } from 'components_new/molecules/FilterBar'
import {
  useResetDashboardUserInput,
  useSetDashboardFilter
} from 'helpers/hooks/Dashboards'

export interface DashboardUserFilterBarProps {
  dashboard: TDashboard | null
  orientation?: FilterBarProps['orientation']
  readOnly?: boolean
  size?: FilterBarProps['size']
  sx?: object
}

const DashboardUserFilterBar = (props: DashboardUserFilterBarProps) => {
  const { dashboard, orientation, readOnly, size, sx } = props
  const dashboardFilter = useDashboardFilter()

  const setDashboardFilter = useSetDashboardFilter()
  const resetDashboardUserInput = useResetDashboardUserInput(dashboard)

  // success
  return (
    <FilterBar
      filter={dashboardFilter}
      orientation={orientation}
      setFilter={setDashboardFilter}
      resetUserInput={resetDashboardUserInput}
      readOnly={readOnly}
      size={size}
      sx={sx}
    />
  )
}

export default DashboardUserFilterBar
